import { defineComponent, ref, nextTick, PropType } from 'vue';
import { ElMessage } from 'element-plus';
import {
  editApproveInfo,
} from '@/api/project-service';
import type { IManageProjectPageListItem, IModifyUserReq } from '@/api/project-service/type.d';
import { UserItem } from '@/api/auth-manage/user/type.d';
import { fuzzyQueryUser } from '@/api/auth-manage/user/index';
import { useFuzzy } from '@/hooks/use-fuzzy';

export default defineComponent({
  components: {
  },
  emits: ['update:visible', 'success'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    approveInfo: {
      type: Object as PropType<IManageProjectPageListItem>,
      default: () => {
        return {};
      },
    },
  },
  setup(props, { emit }) {
    const handleCloseDialog = () => {
      emit('update:visible', false);
    };

    const form = ref<IModifyUserReq>({
      serviceId: '',
      firstHeadOfBackend: '',
      firstHeadOfBackendId: 0,
      firstHeadOfBackendPhone: '',
      firstHeadOfBackendCode: '',
      firstUser: '',
      secondUser: '',
      secondHeadOfBackend: '',
      secondHeadOfBackendCode: '',
      secondHeadOfBackendId: 0,
      secondHeadOfBackendPhone: '',
    });
    const refForm = ref();
    const handleOpenDialog = async () => {
      try {
        await nextTick();
        refForm.value.resetFields();
        const { approveInfo } = props;
        form.value = { ...approveInfo };
        form.value.firstUser = approveInfo.firstHeadOfBackend
          ? `${approveInfo.firstHeadOfBackend}(${approveInfo.firstHeadOfBackendCode})`
          : '';
        form.value.secondUser = approveInfo.secondHeadOfBackend
          ? `${approveInfo.secondHeadOfBackend}(${approveInfo.secondHeadOfBackendCode})`
          : '';
      } catch (e) {
        console.log(e);
      }
    };

    const handleSave = async () => {
      try {
        await nextTick();
        await refForm.value.validate();
        // form.value.firstHeadOfBackend = form.value.firstUser;
        // form.value.secondHeadOfBackend = form.value.secondUser;

        await editApproveInfo(form.value);

        ElMessage.success('提交成功！');
        handleCloseDialog();
        emit('success');
      } catch (err) {
        console.log(err);
      }
    };

    const {
      fuzzyLoading,
      fuzzyResponse,
      fuzzyRemoteMethod,
    } = useFuzzy<any, UserItem[]>({
      params: { keyword: '' },
      keywordKey: 'keyword',
      API: fuzzyQueryUser,
      beforeRequest(param, query) {
        return query;
      },
      beforeResponse(res) {
        return res.data?.map((user: UserItem) => {
          const { name: label, userId: value } = user;
          return { ...user, label, value };
        });
      },
    });

    const handleChangeUser = (userInfo: UserItem) => {
      form.value.firstUser = `${userInfo.name}(${userInfo.bbCode})`;
      form.value.firstHeadOfBackend = userInfo.name;
      form.value.firstHeadOfBackendId = Number(userInfo.userId);
      form.value.firstHeadOfBackendCode = userInfo.bbCode ?? '';
      form.value.firstHeadOfBackendPhone = userInfo.mobilePhone ?? '';
      if (userInfo.name === undefined || userInfo.bbCode === undefined) {
        form.value.firstUser = '';
      }
    };
    const handleChangeSecondUser = (userInfo: UserItem) => {
      form.value.secondUser = `${userInfo.name}(${userInfo.bbCode})`;
      form.value.secondHeadOfBackend = userInfo.name;
      form.value.secondHeadOfBackendId = Number(userInfo.userId);
      form.value.secondHeadOfBackendCode = userInfo.bbCode ?? '';
      form.value.secondHeadOfBackendPhone = userInfo.mobilePhone ?? '';
      if (userInfo.name === undefined || userInfo.bbCode === undefined) {
        form.value.secondUser = '';
      }
    };

    return {
      handleCloseDialog,
      handleOpenDialog,
      form,
      refForm,
      handleSave,
      rules: {
        firstUser: [
          {
            required: true,
            message: '后端服务负责人不能为空',
          },
        ],
      },
      fuzzyLoading,
      fuzzyResponse,
      fuzzyRemoteMethod,
      handleChangeUser,
      handleChangeSecondUser,
    };
  },
  render() {
    return (
      <el-dialog
        title='项目负责人修改'
        modelValue={this.visible}
        onClose={this.handleCloseDialog}
        onOpen={this.handleOpenDialog}
        center
        width="734px"
        top="16vh"
        close-on-press-escape={false}
        close-on-click-modal={false}
        custom-class="el-dialog-inner-scroll"
        v-slots={{
          footer: () => (
            <div class="align-center">
              <el-button size="default" onClick={this.handleCloseDialog}>
                取 消
              </el-button>
              <el-button type="primary" size="default" onClick={this.handleSave}>
                提交
              </el-button>
            </div>
          ),
        }}
      >
        <el-form
          model={this.form}
          label-width="160px"
          size="default"
          rules={this.rules}
          ref="refForm"
        >
          <el-form-item label="后端服务负责人：" prop="firstUser">
            <el-select
              v-model={this.form.firstUser}
              placeholder="请输入服务负责人"
              remote
              filterable
              clearable
              loading={this.fuzzyLoading}
              remote-method={this.fuzzyRemoteMethod}
              style="width: 100%"
              onChange={this.handleChangeUser}
            >
              {this.fuzzyResponse.map(item => (
                <el-option value={item} label={`${item.label}(${item.bbCode})`} key={item.value} />
              ))}
            </el-select>
          </el-form-item>
          <el-form-item label="后端服务备选负责人：" prop="secondUser">
            <el-select
              v-model={this.form.secondUser}
              placeholder="请输入服务负责人"
              remote
              filterable
              clearable
              loading={this.fuzzyLoading}
              remote-method={this.fuzzyRemoteMethod}
              style="width: 100%"
              onChange={this.handleChangeSecondUser}
            >
              {this.fuzzyResponse.map(item => (
                <el-option value={item} label={`${item.label}(${item.bbCode})`} key={item.value} />
              ))}
            </el-select>
          </el-form-item>
        </el-form>
      </el-dialog>
    );
  },
});
